import React from 'react';
import { useTable } from 'react-table';
import ReportData from './ReportData';
function Table({ columns, data }) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  })
  // Render the UI for your table
  return (
    <div className='Report_Table text-center'{...getTableProps()}>
      <div >
        {headerGroups.map(headerGroup => (
          <div className='row' style={{ backgroundColor: "#D9EECF" }}{...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <div className='colR' {...column.getHeaderProps({
                style: {width: column.width },
              })}>{column.render('Header')}</div>
            ))}
          </div>
        ))}
      </div>
      <div {...getTableBodyProps()}>
        {rows.map((row, i) => {
          prepareRow(row)
          return (
            <div className='row' {...row.getRowProps()}>
              {row.cells.map(cell => {
                return <div className='colR' {...cell.getCellProps({
                  style: {width: cell.column.width,textAlign:cell.column.textAlign },
                })}>{cell.render('Cell')}</div>
              })}
            </div>
          )
        })}
      </div>
    </div>
  )
}

function ReportTable(props) {
  const columns = React.useMemo(
    () => [
  
      {
        Header: 'مضامین میں کارکردگی',
        columns: [
          {
            Header: 'نمبر شمار',
            accessor: 'SrNo',
            width: "15%",
            textAlign:"center",
          },
          
          {
            Header: 'مضامین',
            accessor: 'Subject',
            width: "40%",
            textAlign:"right",
          },
          {
            Header: 'کل نمبر',
            accessor: 'TMarks',
            width: "15%",
            textAlign:"center",
          },
          {
            Header: 'حاصل کردہ نمبر',
            accessor: 'OMarks',
            width: "15%",
            textAlign:"center",
          },
          {
            Header: 'حاصل کردہ گریڈ',
            accessor: 'Grade',
            width: "15%",
            textAlign:"left",
          },
        ],
      },
    ],
    []
  )

  const data = React.useMemo(() => ReportData(props), [])

  return (

    <Table   columns={columns} data={data} />

  )
}

export default ReportTable
